import * as React from 'react';
import { SvgIcon, SvgProperties } from '../svg-icon';
import { CardBrandConfig } from '../../webgiving-generated';
import { icon } from './supported-card-brands.less';
import { getCardBrandsFromKeys } from '../../utils/card-utils';

import cardBrandIcons from '../card-brand-icons';

export class SupportedCardBrands extends React.Component<{ brandKeys: string[] }> {
	render() {
		const supportedBrands = getCardBrandsFromKeys(this.props.brandKeys);
		return (
			<div>
				{supportedBrands.map(x => <SvgIcon className={icon} svg={getBrandIconInfo(x)} scale={0.75} title={x.friendlyName} key={x.key} />)}
			</div>
		);
	}
}

function getBrandIconInfo(cardBrand: CardBrandConfig): SvgProperties {
	const [iconKey] = cardBrandIcons.keys().filter(x => x.toLowerCase().indexOf(`paymentmethod-${cardBrand.shortName.toLowerCase()}.svg`) !== -1);

	if (!iconKey) {
		throw new Error(`Card icon for ${cardBrand.shortName} cannot be found. Please add a missing svg.`);
	}

	return (cardBrandIcons(iconKey) as any).default as SvgProperties;
}
